// extracted by mini-css-extract-plugin
module.exports = {"titleOnPrint":"card-with-with-filter_titleOnPrint__Cpzc1","textLinkDark":"card-with-with-filter_textLinkDark__N9ufj"};